@if (scoreboards$ | async; as scoreboards) {
  <div
    @enterFadeIn
    class="rounded-lg border border-gray-200 bg-neutral-98 p-5 shadow-sm">
    <div class="mb-4">
      <h3 class="text-lg font-medium text-primary-60" i18n>Fichaje en curso</h3>
    </div>
    <div class="grid grid-cols-3 gap-4">
      <a
        class="widget-card hover:border-success"
        [routerLink]="goToEmployees"
        [queryParams]="employeesOnlineParam">
        <div class="flex-1 p-3">
          <div
            class="mb-2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-success">
            <mat-icon
              fontIcon="qr_code_scanner"
              class="material-symbols-outlined h-fit w-fit text-xl" />
          </div>
          <div class="scoreboard-widget-counter">
            {{ scoreboards?.openChecks ?? 0 }}
          </div>
          <div class="scoreboard-widget-description">Trabajando</div>
        </div>
        <div class="h-1 w-full rounded-full bg-success"></div>
      </a>
      <a
        class="widget-card hover:border-accent"
        [routerLink]="goToEmployees"
        [queryParams]="employeesOfflineParam">
        <div class="flex-1 p-3">
          <div
            class="mb-2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-accent-95 text-accent">
            <mat-icon
              fontIcon="snooze"
              class="material-symbols-outlined h-fit w-fit text-xl" />
          </div>
          <div class="scoreboard-widget-counter">
            {{ scoreboards?.closeChecks ?? 0 }}
          </div>
          <div class="scoreboard-widget-description">Fuera</div>
        </div>
        <div class="h-1 w-full rounded-full bg-accent"></div>
      </a>
      <a class="widget-card hover:border-primary" [routerLink]="goToEmployees">
        <div class="flex-1 p-3">
          <div
            class="mb-2 inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary-95 text-primary-70">
            <span class="material-icons-outlined text-xl">groups</span>
          </div>
          <div class="scoreboard-widget-counter">
            {{ scoreboards?.totalEmployees ?? 0 }}
          </div>
          <div class="scoreboard-widget-description">Total</div>
        </div>
        <div class="h-1 w-full rounded-full bg-primary-70"></div>
      </a>
    </div>
  </div>
}
